import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Form from '../../Form';
import dataTestValue from 'src/utils/testUtils';

class ActionsForm extends Form {
    static propTypes = {
        ...Form.propTypes,
        actions: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired
        })).isRequired,
        dataTest: PropTypes.string
    };

    static defaultProps = {
        ...Form.defaultProps,
        className: 'actions-form',
        actions: []
    };

    renderForm() {
        const elements = this.props.actions.map(function (action) {
            return (<option key={ action.id } value={ action.id }>{ action.name }</option>);
        });

        return (
            this.getField(
                <select { ...this.getFieldParameters('action')} data-test={this.props.dataTest}>
                    <option />
                    { elements }
                </select>
            )
        );
    }
}

export default ActionsForm;
